import { useInitData } from '../../../../hooks'
import {
  getSectionCanCreatePermission,
  getSectionCanEditPermission,
  getSectionCanViewPermission,
} from '../../../../utils/common'

export function useRentalPortalSectionPermissions({ sectionName }) {
  const { sections } = useInitData()

  return {
    canCreate: getSectionCanCreatePermission(sections, sectionName),
    canEdit: getSectionCanEditPermission(sections, sectionName),
    canView: getSectionCanViewPermission(sections, sectionName),
  }
}
